export default __webpack_public_path__ + "static/media/Prezentacja Chorwacji_Sanja.af36d6b8.pdf";